import { render } from "./MiscDemo.vue?vue&type=template&id=0bb04666"
import script from "./MiscDemo.vue?vue&type=script&lang=js"
export * from "./MiscDemo.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__